import { Component, OnInit } from '@angular/core';
import * as CanvasJS from 'src/assets/js/canvasjs.min';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {MatIconRegistry, MatSnackBar} from '@angular/material';
import {Router} from '@angular/router';
import {NgxXml2jsonService} from 'ngx-xml2json';
import {DomSanitizer} from '@angular/platform-browser';

declare let $;
@Component({
  selector: 'app-metrics-dashboard',
  templateUrl: './metrics-dashboard.component.html',
  styleUrls: ['./metrics-dashboard.component.css']
})
export class MetricsDashboardComponent implements OnInit {
  serviceAvailability = [];
  cloudwatchMetrics: any;
  constructor(private confPost: ConfService) {
  }
  ngOnInit() {

    let dataPoints = [];
    let dpsLength = 0;
    let chart = new CanvasJS.Chart("chartContainer", {
      exportEnabled: false,
      title: {
        text: "Api Latency"
      },
      data: [{
        type: "spline",
        dataPoints: dataPoints
      }]
    });
    const that = this;
    this.serviceAvailability = [[1,25],[2,21],[3,21],[4,24],[5,25],[6,27],[7,29],[8,28],[9,32],[10,34],[11,32],[12,37],[13,42],[14,41],[15,40],[16,39],[17,40],[18,43],[19,44]];
      $.each(that.serviceAvailability, function (key, value) {
        dataPoints.push({x: value[0], y: parseInt(value[1])});
        dpsLength = that.serviceAvailability.length;
      });
      chart.render();

    let PieChart = new CanvasJS.Chart("pieChartContainer", {
      theme: "light2",
      animationEnabled: true,
      exportEnabled: false,
      title:{
        text: "Service Availability"
      },
      data: [{
        type: "pie",
        showInLegend: true,
        toolTipContent: "<b>{name}</b>: ${y} (#percent%)",
        indexLabel: "{name} - #percent%",
        dataPoints:[
          { y: 450, name: "Food" },
          { y: 120, name: "Insurance" },
          { y: 300, name: "Traveling" },
          { y: 800, name: "Housing" },
          { y: 150, name: "Education" },
          { y: 150, name: "Shopping"},
          { y: 250, name: "Others" }
        ]
      }]
    });

    PieChart.render();
    // this.confPost.getCloudWatchMetrics(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
    //   this.cloudwatchMetrics = data;
    //   let barChart = new CanvasJS.Chart("barChartContainer", {
    //     animationEnabled: true,
    //     exportEnabled: false,
    //     title: {
    //       text: "No. of API Hits"
    //     },
    //     data: [{
    //       type: "column",
    //       dataPoints: this.cloudwatchMetrics
    //     }]
    //   });
    //   barChart.render();
    // });

  }
}
